<template lang="html">
  <div>
      <div class="inner-page">
          <Header>我的收藏</Header>
          <div class="headNav">
               <div :class="['nav-item',{'act':navAct==1}]" @click="navChange(0)">单曲</div>
               <div :class="['nav-item',{'act':navAct==2}]" @click="navChange(1)">专辑</div>
          </div>
          <div class="scroll-list" :style="'height:' + scrollH + 'px'">
                <div class="scroll-inner">
                      <van-swipe :show-indicators="false"
                                 :duration="300"
                                 :loop="false"
                                 ref="navSwper"
                                 @change="navChange">
                        <van-swipe-item v-for="(item,index) in listArr" :key="index">
                                 <div class="swpInner">
                                       <AlbumList :listDat="item" :listType="3-navAct" class="album-list" @unCollect="unCollect" />
                                       <div class="tapMore">
                                            <van-loading v-if="isLoading" class="load-icon" size="21" color="#af2d2d">加载中...</van-loading>
                                            <div class="btn" v-else-if="current[navAct-1].allPage>current[navAct-1].no" @click="onRefresh">加载更多</div>
                                       </div>
                                       <Loading :firstLoading="firstLoading" />
                                 </div>
                          </van-swipe-item>
                      </van-swipe>
                </div>
                <Footer />
          </div>

      </div>


  </div>
</template>

<script>
import vEmits from "@/utils/vEmits";
import AlbumList from "@/components/AlbumList";
import Loading from "@/components/loading";
import { userCollect,unCollect } from "@/api/me";

export default {
     components:{
         AlbumList,
         Loading
     },
     data(){
         return{
             navAct:1,
             listArr:[[],[]],
             current:[{
                 no:1,
                 allPage:0,
             },{
                 no:1,
                 allPage:0
             }],
             listH:'',
             firstLoading:true,
             isLoading:false
         }
     },
     methods:{
        navChange:function(inx){
            this.navAct = inx + 1;
            this.$refs.navSwper.swipeTo(inx);
            let nowAct = this.current[this.navAct - 1];
            if(nowAct.allPage < nowAct.no){
                this.getList();
            }
        },
        getList:function(){
            let vues = this;
            let nowPages = vues.current[this.navAct - 1];
            if(nowPages.no == 1){
                 this.firstLoading = true;
            }else{
                 this.isLoading = true;
            }
            userCollect({
                collectType:3 - this.navAct,
                size:10,
                no:nowPages.no
            }).then(res => {
                if(nowPages.no == 1){
                    vues.listArr[this.navAct - 1] = res.collectList;
                    vues.firstLoading = false;
                }else{
                    vues.isLoading = false;
                    vues.listArr[this.navAct - 1] = vues.listArr[this.navAct - 1].concat(res.collectList);
                }
                vues.current[this.navAct - 1].allPage = res.totalPages;

            })
        },
        unCollect:function(e){
            let nowArr = this.listArr[this.navAct - 1];
            // let vues = this;
            unCollect({id:e.id}).then(res => {
                window.console.log(res);
                for(let i = 0;i < nowArr.length;i++){
                    if(nowArr[i].id == e.id){
                       nowArr.splice(i,1);
                       break;
                    }
                }
            }).catch(errs => {
                window.console.log(errs);
                vEmits.$emit('show','请先登录');
            })
        },
        onRefresh:function(){
            this.current[this.navAct - 1].no++;
            this.getList();
        },
     },
     created:function(){
        this.scrollH = document.documentElement.clientHeight - 142;
        this.getList();
     }
}
</script>

<style lang="css" scoped>

.headNav{
    height: 42px;
    display: flex;
    background: white;
}

.headNav .nav-item{
    flex-grow: 1;
    height: 41px;
    display: flex;
    align-items: center;
    justify-content: space-around;
    border-bottom: 1px solid #efefef;
}

.headNav .nav-item.act{
    border-bottom: 1px solid #af2d2d;
    color: #af2d2d;
}

/* 列表 */

.scroll-list{
    overflow-x: scroll;
}

.scroll-inner{
    min-height: 300px;
    background: white;
}

.swpInner{
    min-height: 300px;
}

/* 加载更多 */

.tapMore{
     height: 45px;
     background: white;
     display: flex;
     align-items: center;
     justify-content: space-around;
}

.tapMore .btn{
     display: inline-block;
     padding: 6px 18px;
     color: #666666;
     font-size: 15px;
     margin: 0 auto;
     color: #999999;
}

</style>
